import React, { useState } from 'react';
import { CircularProgress } from '@mui/material';
import {
  ActionsContainer,
  PdfButton,
  DocxButton,
  WorkflowButton,
} from './DocActions.styles';

const DocActions = ({ onDownloadPdf, onDownloadDocX }) => {
  const [loadingPdf, setLoadingPdf] = useState(false);
  const [loadingDocx, setLoadingDocx] = useState(false);

  const handlePdfDownload = async () => {
    setLoadingPdf(true);
    try {
      await onDownloadPdf();
    } finally {
      setLoadingPdf(false);
    }
  };

  const handleDocxDownload = async () => {
    setLoadingDocx(true);
    try {
      await onDownloadDocX();
    } finally {
      setLoadingDocx(false);
    }
  };

  return (
    <ActionsContainer>
      <PdfButton onClick={handlePdfDownload} disabled={loadingPdf}>
        {loadingPdf ? <CircularProgress size={20} color="inherit" /> : null}
      </PdfButton>

      <DocxButton onClick={handleDocxDownload} disabled={loadingDocx}>
        {loadingDocx ? <CircularProgress size={20} color="inherit" /> : null}
      </DocxButton>

      <WorkflowButton />
    </ActionsContainer>
  );
};

export default DocActions;
